<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :resourceName="$tc('resources.commission.name', 1)"
                ref="table"
            >
                <template #paid_at="{ item }">{{
                    item.formattedPaidAt
                }}</template>

                <template #totalValue="{ item }">{{
                    item.formattedTotalValue
                }}</template>

                <template #status="{ item }">
                    <v-chip
                        class="ml-3"
                        color="success"
                        text-color="white"
                        v-if="item.paid"
                        small
                    >
                        <v-avatar left>
                            <v-icon small>mdi-checkbox-marked-circle</v-icon>
                        </v-avatar>
                        Pago
                    </v-chip>
                    <v-chip
                        class="ml-3"
                        color="indigo"
                        text-color="white"
                        v-else-if="item.reviewed"
                        small
                    >
                        <v-avatar left>
                            <v-icon small>mdi-checkbox-marked-circle</v-icon>
                        </v-avatar>
                        Revisado
                    </v-chip>
                    <v-chip
                        class="ml-3"
                        color="indigo"
                        text-color="white"
                        v-else-if="item.confirmed"
                        small
                    >
                        <v-avatar left>
                            <v-icon small>mdi-checkbox-marked-circle</v-icon>
                        </v-avatar>
                        Confirmado
                    </v-chip>
                    <v-chip
                        color="blue-grey lighten-2"
                        text-color="white"
                        v-else-if="item.is_current_month"
                        class="ml-3"
                        small
                    >
                        <v-avatar left>
                            <v-icon small>mdi-clock</v-icon>
                        </v-avatar>
                        Pendente
                    </v-chip>
                    <v-chip
                        color="red lighten-2"
                        text-color="white"
                        v-else
                        class="ml-3"
                        small
                    >
                        <v-avatar left>
                            <v-icon small>mdi-close</v-icon>
                        </v-avatar>
                        Vencida
                    </v-chip>
                </template>

                <template #action="{ item }">
                    <action-button
                        v-if="item.invoice_url"
                        icon="mdi-file-code-outline"
                        label="Nota Fiscal"
                        :href="item.invoice_url"
                        target="__blank"
                    />

                    <action-button
                        v-if="item.payment_voucher_url"
                        icon="mdi-file-document-box-check-outline"
                        label="Comprovante de Pagamento"
                        :href="item.payment_voucher_url"
                        target="__blank"
                    />

                    <action-button
                        icon="mdi-eye"
                        :label="$t('form.actions.show')"
                        @click="
                            $router.push({
                                name: 'commission.show',
                                params: { id: item.id },
                            })
                        "
                    />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import ActionButton from '@/shared/components/ActionButton'
import Commission from '@/models/Commission'
import SaralaTable from '@/shared/components/SaralaTable'
export default {
    components: {
        SaralaTable,
        ActionButton,
    },

    computed: {
        model() {
            return new Commission()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                this.$tc('resources.commission.name', 1),
            )
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.commission.name', 1),
                }),
            )
        },
    },
}
</script>

<style></style>
